export default __webpack_public_path__ + "static/media/npm.5620a716.svg";